import React from 'react';
import FixedLock from './FixedLock'
import './App.css';

function App() {

  return (
    <div className="App">
    <FixedLock></FixedLock>
    </div>
  );
}

export default App;
